import React from 'react'

export default function useKeyHandler() {
	const [keysPressed, setKeysPressed] = React.useState([])
	const [keyEvent, setKeyEvent] = React.useState(null)

	document.onkeydown = function (event) {
		const code = event.keyCode
		if (!isKeyPressed(code)) {
			setKeysPressed((state) => [code, ...state])
		}
		setKeyEvent({ eventName: 'keydown', keyCode: code })
		//console.log('add key ' + event.keyCode + ' keysPressed: ' + JSON.stringify(keysPressed));
	}

	document.onkeyup = function (event) {
		const code = event.keyCode
		//console.log('remove key: ' + event.keyCode);
		if (isKeyPressed(code)) {
			setKeysPressed((state) => state.filter((key) => key !== event.keyCode))
		}
		setKeyEvent({ eventName: 'keyup', keyCode: code })
	}

	function isKeyPressed(code) {
		return keysPressed.indexOf(code) >= 0
	}

	return [keyEvent, keysPressed]
}
